const PARENT_SITE_CRUMBS = [
  { label: "Home", href: "https://www.reliancefoundation.org/" },
  { label: "What We Do", href: "https://www.reliancefoundation.org/what-we-do" },
  { label: "Education", href: "https://www.reliancefoundation.org/education" },
]

/**
 * Figma / ENT breadcrumb trail under the header. Parent crumbs link out to
 * reliancefoundation.org; the current page label is local.
 */
export function Breadcrumb({ current }: { current: string }) {
  return (
    <nav aria-label="Breadcrumb" className="bg-transparent">
      <div className="mx-auto max-w-[1200px] border-b border-[#bcb7b5] px-4 sm:px-6">
        <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 py-2.5 font-body text-[14px] font-medium leading-none text-brand-teal">
          {PARENT_SITE_CRUMBS.map((crumb) => (
            <li key={crumb.href} className="flex items-center gap-2">
              <a
                href={crumb.href}
                target="_blank"
                rel="noopener noreferrer"
                title={`${crumb.label} (opens in a new tab)`}
                className="transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                {crumb.label}
              </a>
              <span className="text-[#635551]" aria-hidden>
                /
              </span>
            </li>
          ))}
          <li aria-current="page" className="font-medium text-brand-teal">
            {current}
          </li>
        </ol>
      </div>
    </nav>
  )
}
